
const dateRegex = /[0-9]{4}-[0-9]{2}-[0-9]{2}/;
const phoneNumberRegex = /^((([+][s]{0,1})|([0]{2}[s-]{0,1}))([358]{3})([s-]{0,1})|([0]{1}))(([1-9]{1}[0-9]{0,1})([s-]{0,1})([0-9]{2,4})([s-]{0,1})([0-9]{2,4})([s-]{0,1}))([0-9]{0,3}){1}$/;
const postCodeRegex = /[0-9]{5}/;

const bannedWords = ['admin@',
  'abuse@',
  'postmaster@',
  'noc@',
  'root@',
  'sysadmin@',
  'compliance@',
  'registrar@',
  'support@',
  'spam@',
  'hostmaster@',
  'info@',
  'help@',
  'jobs@',
  'press@',
  'all@',
  'billing@',
  'devnull@',
  'dns@',
  'everyone@',
  'feedback@',
  'ftp@',
  'inoc@',
  'inquiries@',
  'investorrelations@',
  'ispfeedback@',
  'ispsupport@',
  'list-request@',
  'list@',
  'maildaemon@',
  'marketing@',
  'news@',
  'nobody@',
  'null@',
  'phish@',
  'phishing@',
  'privacy@',
  'sales@',
  'security@',
  'service@',
  'subscribe@',
  'tech@',
  'trouble@',
  'undisclosed-recipients@',
  'unsubscribe@',
  'usenet@',
  'uucp@',
  'webmaster@',
  'www@',
  'paska',
  'kusi',
  'vittu',
  'perkele',
  'spam',
  'roskaposti',
  'test',
  'testi',
  'qwe',
  'asd',
  'dsa',
  'poliisi',]


export {dateRegex, phoneNumberRegex, bannedWords, postCodeRegex};
